export type ApiKeyScope = 'events:read';

export const API_KEY_SCOPES: { value: ApiKeyScope; label: string }[] = [{ value: 'events:read', label: 'Events (read)' }];

export interface IApiKey {
    id: string;
    user_id: number;
    title: string; // masked key, e.g. api_key_****abcde
    description: string | null;
    scope: ApiKeyScope[];
    date_revoked: string | null;
    date_last_used: string | null;
    date_created: string;
    date_modified: string;
}

/**
 * Returned only once, right after the key is created. Contains the plain-text
 * `key` which is never exposed again by the API.
 */
export interface IApiKeyCreated extends IApiKey {
    key: string;
}

export interface ICreateApiKey {
    description?: string;
    scope: ApiKeyScope[];
}
